// extracted by mini-css-extract-plugin
export var container = "_uc-0";
export var table = "_uc-2";
export var tableWrapper = "_uc-1";